import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useState, useRef } from 'react';
import UserOnglet from "../../user/UserOnglet";
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import useIsTouchDevice from "../../../hooks/useIsTouchDevice";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicDeleteAccount = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
    
  const isTouchDevice = useIsTouchDevice();
  const [ongletActif, setOngletActif] = useState(isTouchDevice ? {label: 'Navigateur mobile', id: 2} : {label: 'Ordinateur de bureau', id: 1});
  
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Nous regretterions de vous voir partir, mais si vous avez décidé de quitter Wodzone définitivement, voici la marche à suivre.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part mb-8">{anchorsParts[0].content}</p>
              <p className="help-text">Lorsque vous fermez et supprimez votre compte définitivement :</p>
              <ul>
                {/* <li className="pl-8 mb-16">Pour des raisons de sécurité, nous vérifions votre identité avant d'accepter votre demande de suppression.</li> */}
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    Une fois votre demande traitée, vos données personnelles sont définitivement supprimées, 
                    à l'exception de certaines informations que la loi nous autorise ou nous oblige à conserver, comme indiqué dans notre<a target='_blank' className="link" href="/topics/about/62">Politique de confidentialité.</a>
                  </p>
                </li>
              </ul>
              <p className="help-text mt-32">
                Une fois votre compte supprimé, vous ne pouvez pas le réactiver, récupérer des données ni en restaurer l'accès. 
                Vous devrez créer un nouveau compte si vous souhaitez réutiliser Wodzone. 
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Supprimer son compte sur ordinateur</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Cliquez sur <strong>Profil</strong> {'>'} <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings`}>Compte.</a></p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          En bas des menus, de dessous de <strong>Besoin de supprimer votre compte ?</strong> cliquez sur
                          <a target='_blank' className="link" href="/account-settings/compte/close">M'en occuper maintenant.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">cliquez sur le bouton<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/close/reason`}>Poursuivre la clôture.</a></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Renseignez la raison pour laquelle vous shouaitez supprimer votre compte. Puis cliquez sur <strong>continuer</strong></p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Confirmer votre demande de suppression en cliquant sur <strong>Clôturer le compte</strong></p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Supprimer son compte sur votre navigateur mobile</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez dans le navbar sur votre <strong>Avatar</strong> ou sur <i className="fa-solid fa-bars fz-18 ml-8 mr-8"></i> {'>'} 
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings`}>Mon Compte.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Dans Paramètres du compte {'>'} <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte`}>Compte.</a></p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Appuyer sur la section<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/close`}>Clôturer mon compte.</a></p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">appuyer sur le bouton<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/close/reason`}>Poursuivre la clôture.</a></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Renseignez la raison pour laquelle vous shouaitez supprimer votre compte. Puis appuyer sur <strong>continuer</strong></p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Confirmer votre demande de suppression en appuyant sur <strong>Clôturer le compte</strong></p></li>
                    </ol>
                  </div>
              }
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicDeleteAccount